import { toast } from '@quinyx/ui';
import axios, { AxiosError, AxiosResponse } from 'axios';

import i18n from '../../i18n';
import { CONFIG } from '../config';
import { ERROR } from '../enums';
import { IErrorResponse } from '../interfaces';

const checkIfAuthorisationError = (error: AxiosError) => {
  if (
    error.response?.data &&
    typeof error.response.data === 'object' &&
    'error' in error.response.data &&
    error.response.data.error === ERROR.UNAUTHORIZED
  ) {
    toast(i18n.t('toast.unauthorisedRedirect'), 'negative');
    setTimeout(() => {
      window.location.href = CONFIG.MANAGER_PORTAL;
    }, 3000);
  }
  throw error;
};

export const get = <T = any>(url: string): Promise<T> =>
  axios
    .get<T>(url, { withCredentials: true })
    .then((res) => res.data)
    .catch((e: IErrorResponse) => checkIfAuthorisationError(e));

export const put = <T = any>(url: string, data: any) =>
  axios
    .put<T>(url, data, { withCredentials: true })
    .then((res) => res.data)
    .catch(checkIfAuthorisationError);

export const post = <TResponse = any, TPayload = any>(
  url: string,
  data: TPayload,
) =>
  axios
    .post<TPayload, AxiosResponse<TResponse>>(url, data, {
      withCredentials: true,
    })
    .then((res) => res.data)
    .catch(checkIfAuthorisationError);

export const del = <TResponse = any, TPayload = any>(
  url: string,
  data?: TPayload,
) =>
  axios
    .delete<TPayload, AxiosResponse<TResponse>>(url, {
      data,
      withCredentials: true,
    })
    .then((res) => res.data)
    .catch(checkIfAuthorisationError);

export const patch = <T = any>(url: string, data: any) =>
  axios
    .patch<T>(url, data, { withCredentials: true })
    .then((res) => res.data)
    .catch(checkIfAuthorisationError);
